import React from 'react';
import TR from '../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';

function SongbookWelcome(props) {

  const handleKeyDown = (event) => {
if (event.key === 'Enter') {
      props.onClose();
    }
  };

  return (
    <BDialog disableRestoreFocus open={props.open} onKeyDown={handleKeyDown}  onClose={props.onClose}>
      <DialogContent>
        <div dangerouslySetInnerHTML={{__html: props.welcomeHtml}}>

        </div>
      </DialogContent>
      <DialogActions>
      <Stack direction="row" spacing={6} justifyContent="center">
        <Button color="success" onClick={props.onClose}>OK</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default SongbookWelcome;